export default __webpack_public_path__ + "media/images/celeste_feather-e2c6ca1aff11582a9310232517762ebf.png";